// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"dd22e340","247":"3d0f3a83","295":"2a8e3f20","480":"97d23161","988":"fef03274"}[chunkId] + ".chunk.js";
};